import { DataBean } from "../DataBean";

export class WorkMaintenanceOrder extends DataBean {
  public async getWorkMaintenanceOrderCatalog8(
    idFixedAsset: number,
    idItem: number,
    accountID: number,
    regex: string,
    ticketCode: number,
    state: number,
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getWorkMaintenanceOrderCatalog_Number_Number_Number_String_Number_Number_Number_Number",
      [
        idFixedAsset,
        idItem,
        accountID,
        regex,
        ticketCode,
        state,
        page,
        recordsPerPage,
      ]
    );
  }

  public async getWorkMaintenanceOrderRender(properties: any, maxRows: number, props: any, fromDate: any, uptoDate: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getWorkMaintenanceOrderRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [properties, maxRows, props, fromDate, uptoDate]
    );
  }

  public async updateWorkMaintenanceOrder(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.fixedassets.WorkMaintenanceOrder_updateWorkMaintenanceOrder_com.quickdataerp.bean.fixedassets.WorkMaintenanceOrder",
      [
        {
          DataBeanProperties: bean,
          DataBeanName:
            "com.quickdataerp.bean.fixedassets.WorkMaintenanceOrder",
        },
      ]
    );
  }

  public async changeWorkMaintenanceOrderState(IDWorkMaintenanceOrder: number, State: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.quickdataerp.bean.fixedassets.WorkMaintenanceOrder_changeWorkMaintenanceOrderState_Number_Number",
      [IDWorkMaintenanceOrder, State]
    );
  }
}
